import { useMemo } from "react";
import { useAccountState } from "@made-people/grease-account";
import { useTranslate } from "@made-people/grease-translations";

type TimeOfDay = "morning" | "day" | "afternoon" | "evening";

const getTimeOfDay = (): TimeOfDay => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 14) return "day";
  if (hour >= 14 && hour < 18) return "afternoon";
  return "evening";
};

const GREETING_KEYS: Record<TimeOfDay, string> = {
  morning: "Account_Greeting_Morning",
  day: "Account_Greeting_Day",
  afternoon: "Account_Greeting_Afternoon",
  evening: "Account_Greeting_Evening",
};

export const useGreeting = (): string => {
  const account = useAccountState();
  const translate = useTranslate();
  const timeOfDay = useMemo(() => getTimeOfDay(), []);

  return translate(GREETING_KEYS[timeOfDay], {
    firstName: account.customer?.firstName ?? "",
  });
};
